export default "__VITE_ASSET__DGS8NFxM__"